import { StoppableEventInterface } from './stoppable-event.interface';
import { EventSubscriberInterface } from './subscriber/event-subscriber.interface';
import { Event } from '../../../components/event-manager/event';
import { Events } from '../../../components/event-manager/event/events';

export type Handler<T = unknown> = (event: T, eventName: Events) => void | Promise<void>;
export type ObjectHandler = { [key in Events]?: Handler<Event> };

export const instanceOfStoppableEventInterface = (object: object): object is StoppableEventInterface =>
  'isPropagationStopped' in object;

export interface EventManagerInterface {
  addListener (type: Events, handler: Handler<Event> | [ object, string ] | ObjectHandler): void;

  removeListener (type: Events, handler: Handler<Event> | [ object, string ] | ObjectHandler): void;

  addSubscriber (subscriber: EventSubscriberInterface): void;

  removeSubscriber (subscriber: EventSubscriberInterface): void;

  dispatch<T extends Event> (type: Events, event?: T): Promise<T>;

  getListeners (type: Events): Handler<Event>[];

  hasListeners (): boolean;
}
